import React from 'react';
import _isEmpty from 'lodash/isEmpty';
import { AddressPropTypes } from 'utils/PropTypesValues';
import { Typography, Box } from '@material-ui/core';

const DefaultAddress = ({ address }) => {
  if (_isEmpty(address)) return null;

  const { firstName = '', lastName = '', line1 = '', city = '', state = '', country = '', zip = '' } = address;

  const name = `${firstName} ${lastName}`;

  return (
    <Box data-testid="billing-address-box">
      <Typography>{name}</Typography>
      <Typography>{line1}</Typography>
      <Typography>{`${city}, ${state} ${country} ${zip}`}</Typography>
    </Box>
  );
};

DefaultAddress.propTypes = {
  address: AddressPropTypes,
};

export default DefaultAddress;
